import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import '../../../styles/RusticGarden.css';

const RusticGarden = ({ isPreview = true }) => {
  const { coupleNames } = useParams();
  const [isRevealed, setIsRevealed] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const [rsvpData, setRsvpData] = useState({
    name: '',
    attending: '',
    guests: '1',
    message: ''
  });

  // Parse couple names
  const formatCoupleNames = (names) => {
    if (!names) return 'Bride & Groom';
    return names
      .split('-')
      .map(name => name.charAt(0).toUpperCase() + name.slice(1).toLowerCase())
      .join(' & ');
  };

  const invitationData = {
    coupleNames: formatCoupleNames(coupleNames),
    groomName: coupleNames?.split('-')[0]?.charAt(0).toUpperCase() + coupleNames?.split('-')[0]?.slice(1).toLowerCase() || 'David',
    brideName: coupleNames?.split('-')[1]?.charAt(0).toUpperCase() + coupleNames?.split('-')[1]?.slice(1).toLowerCase() || 'Emma',
    weddingDate: 'May 25, 2026',
    weddingDay: 'Saturday',
    ceremonyTime: '2:00 PM',
    churchName: 'Garden Chapel at The Farm',
    churchAddress: 'San Benito, Batangas',
    receptionVenue: 'The Barn at Sunset Ranch',
    receptionAddress: 'Lipa City, Batangas',
    message: 'With joy in our hearts, we invite you to witness the beginning of our forever.',
    dressCode: 'Garden Formal',
    colors: 'Sage Green & Terracotta'
  };

  useEffect(() => {
    const timer = setTimeout(() => setIsRevealed(true), 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="rustic-garden">
      {/* Nature Elements */}
      <div className="nature-elements">
        <div className="leaf leaf-1">🌿</div>
        <div className="leaf leaf-2">🍃</div>
        <div className="leaf leaf-3">🌿</div>
        <div className="leaf leaf-4">🍃</div>
        <div className="leaf leaf-5">🌾</div>
        <div className="leaf leaf-6">🌿</div>
      </div>

      {/* Main Content */}
      <div className={`rustic-container ${isRevealed ? 'revealed' : ''}`}>
        {/* Navigation */}
        <nav className="rustic-nav">
          <button 
            className={activeSection === 'home' ? 'active' : ''} 
            onClick={() => setActiveSection('home')}
          >
            Home
          </button>
          <button 
            className={activeSection === 'details' ? 'active' : ''} 
            onClick={() => setActiveSection('details')}
          >
            Details
          </button>
          <button 
            className={activeSection === 'rsvp' ? 'active' : ''} 
            onClick={() => setActiveSection('rsvp')}
          >
            RSVP
          </button>
        </nav>

        {/* Home Section */}
        {activeSection === 'home' && (
          <section className="rustic-section home-section">
            <div className="rustic-frame">
              <div className="botanical-border">
                <div className="corner-leaf top-left">🌿</div>
                <div className="corner-leaf top-right">🌿</div>
                <div className="corner-leaf bottom-left">🍃</div>
                <div className="corner-leaf bottom-right">🍃</div>
                
                <div className="home-content">
                  <p className="invitation-prefix">Together with their families</p>
                  
                  <div className="couple-names">
                    <span className="name">{invitationData.groomName}</span>
                    <span className="and-symbol">&</span>
                    <span className="name">{invitationData.brideName}</span>
                  </div>

                  <div className="rustic-divider">
                    <span className="leaf-icon">🌿</span>
                  </div>

                  <p className="invitation-text">{invitationData.message}</p>

                  <div className="wedding-date-display">
                    <div className="date-wreath">
                      <span className="wreath-left">❧</span>
                      <div className="date-content">
                        <span className="day-name">{invitationData.weddingDay}</span>
                        <span className="full-date">May 25, 2026</span>
                        <span className="time">{invitationData.ceremonyTime}</span>
                      </div>
                      <span className="wreath-right">❧</span>
                    </div>
                  </div>

                  <button 
                    className="view-details-btn"
                    onClick={() => setActiveSection('details')}
                  >
                    View Details
                  </button>
                </div>
              </div>
            </div>
          </section>
        )}

        {/* Details Section */}
        {activeSection === 'details' && (
          <section className="rustic-section details-section">
            <h2 className="section-title">
              <span className="title-leaf">🌿</span>
              Wedding Details
              <span className="title-leaf">🌿</span>
            </h2>

            <div className="details-grid">
              <div className="detail-card">
                <div className="detail-icon">🏡</div>
                <h3>Ceremony</h3>
                <p className="venue-name">{invitationData.churchName}</p>
                <p className="venue-address">{invitationData.churchAddress}</p>
                <p className="venue-time">{invitationData.ceremonyTime}</p>
              </div>

              <div className="detail-card">
                <div className="detail-icon">🎊</div>
                <h3>Reception</h3>
                <p className="venue-name">{invitationData.receptionVenue}</p>
                <p className="venue-address">{invitationData.receptionAddress}</p>
                <p className="venue-time">Following the ceremony</p>
              </div>

              <div className="detail-card">
                <div className="detail-icon">👔</div>
                <h3>Dress Code</h3>
                <p className="dress-info">{invitationData.dressCode}</p>
                <p className="color-info">Colors: {invitationData.colors}</p>
              </div>

              <div className="detail-card">
                <div className="detail-icon">🌻</div>
                <h3>Gift Guide</h3>
                <p className="gift-message">Your love and presence is our treasure.</p>
                <p className="gift-note">Monetary blessings are appreciated.</p>
              </div>
            </div>

            <div className="countdown-section">
              <h3>🌾 Days Until We Say I Do 🌾</h3>
              <div className="countdown-display">
                <div className="countdown-item">
                  <span className="countdown-number">--</span>
                  <span className="countdown-label">Days</span>
                </div>
                <div className="countdown-item">
                  <span className="countdown-number">--</span>
                  <span className="countdown-label">Hours</span>
                </div>
                <div className="countdown-item">
                  <span className="countdown-number">--</span>
                  <span className="countdown-label">Mins</span>
                </div>
                <div className="countdown-item">
                  <span className="countdown-number">--</span>
                  <span className="countdown-label">Secs</span>
                </div>
              </div>
            </div>

            <button 
              className="rsvp-cta-btn"
              onClick={() => setActiveSection('rsvp')}
            >
              RSVP Now
            </button>
          </section>
        )}

        {/* RSVP Section */}
        {activeSection === 'rsvp' && (
          <section className="rustic-section rsvp-section">
            <h2 className="section-title">
              <span className="title-leaf">🌿</span>
              RSVP
              <span className="title-leaf">🌿</span>
            </h2>

            <form className="rustic-rsvp-form" onSubmit={(e) => e.preventDefault()}>
              <p className="rsvp-intro">We can't wait to celebrate with you!</p>
              <p className="rsvp-deadline">Please respond by April 25, 2026</p>

              <div className="form-group">
                <label>Your Name</label>
                <input
                  type="text"
                  name="name"
                  value={rsvpData.name}
                  placeholder="Enter your full name"
                  disabled={isPreview}
                />
              </div>

              <div className="form-group">
                <label>Will you be joining us?</label>
                <div className="attendance-options">
                  <label className={`attendance-option ${isPreview ? 'disabled' : ''}`}>
                    <input
                      type="radio"
                      name="attending"
                      value="yes"
                      disabled={isPreview}
                    />
                    <span className="option-icon">🌻</span>
                    <span className="option-text">Happily Accepts</span>
                  </label>
                  <label className={`attendance-option ${isPreview ? 'disabled' : ''}`}>
                    <input
                      type="radio"
                      name="attending"
                      value="no"
                      disabled={isPreview}
                    />
                    <span className="option-icon">🍂</span>
                    <span className="option-text">Regretfully Declines</span>
                  </label>
                </div>
              </div>

              <div className="form-group">
                <label>Number of Guests</label>
                <select
                  name="guests"
                  value={rsvpData.guests}
                  disabled={isPreview}
                >
                  <option value="1">1 Guest</option>
                  <option value="2">2 Guests</option>
                  <option value="3">3 Guests</option>
                  <option value="4">4 Guests</option>
                </select>
              </div>

              <div className="form-group">
                <label>Warm Wishes (Optional)</label>
                <textarea
                  name="message"
                  value={rsvpData.message}
                  placeholder="Share your blessings..."
                  rows="3"
                  disabled={isPreview}
                />
              </div>

              <button type="submit" className="submit-rsvp-btn" disabled={isPreview}>
                Send RSVP
              </button>
            </form>
          </section>
        )}

        {/* Watermark */}
        <div className="rustic-watermark">
          <a href="/invitations" className="back-to-templates-btn">← Back to Templates</a>
          <p>Created with ♥ by <a href="https://logicatechnology.com" target="_blank" rel="noopener noreferrer">Logica Technology</a></p>
        </div>
      </div>
    </div>
  );
};

export default RusticGarden;
